export default __webpack_public_path__ + "static/media/Conservador.c68aaed8.svg";